export default __webpack_public_path__ + "static/media/icon_rawhtml.3e88e002.svg";